import type { IntlShape } from "react-intl"
import { pricingFieldMessages } from "../hooks/pricingField.messages"
import type { BasicPricingFields } from "./basicPricing.fields"
import { basicPricingFieldNames } from "./basicPricing.fields"

export const getBasicPricingFields = (
	isDraft: boolean,
	formatMessage: IntlShape["formatMessage"],
	isVatDeductibleAvailable: boolean,
): BasicPricingFields => {
	return {
		minimumPrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.minimumPriceLabel),
			name: basicPricingFieldNames.minimumPriceName,
			type: "currency",
		},
		price: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.customerPriceLabel),
			maxLength: 17,
			name: basicPricingFieldNames.priceName,
			required: true,
			type: "currency",
		},
		purchasePrice: {
			debounced: isDraft ? 500 : undefined,
			label: formatMessage(pricingFieldMessages.purchasePriceLabel),
			name: basicPricingFieldNames.purchasePriceName,
			type: "currency",
		},
		vatDeductible: isVatDeductibleAvailable
			? {
					label: formatMessage(pricingFieldMessages.vatDeductibleLabel),
					name: basicPricingFieldNames.vatDeductibleName,
				}
			: undefined,
	}
}
